import VideoPlayer from './VideoPlayer.vue';
import VodControls from './VodControls.vue';
import VideoPlayerStates from './VideoPlayerStates.js';

export const VideoStates = VideoPlayerStates;
export { VodControls };
export { PLAYER_STATE, TRICK_SPEEDS, SEEK_STEP, formatTime } from '@/helpers/VodPlayer';

export default VideoPlayer;



// WEBPACK FOOTER //
// ./src/components/VideoPlayer/index.js